var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loader","data-html":'<div>Page loaded</div>',"data-position":"bottom center"}},[_c('i',{staticClass:"circle icon studiogrey",attrs:{"id":"loading"}})])}
var staticRenderFns = []

export { render, staticRenderFns }